import { render, staticRenderFns } from "./PcqDsis.vue?vue&type=template&id=11725b0f&"
import script from "./PcqDsis.vue?vue&type=script&lang=js&"
export * from "./PcqDsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports